import ForestMassUploadForm from '@/components/ForestMassUploadForm';
import CenteredLayout from '@/components/Layouts/CenteredLayout';
import {useController} from './controller';

const ForestMassUploadFormView = () => {
  const {appraisers, species, onUploadForestMass, onBack} = useController();

  return (
    <CenteredLayout>
      <ForestMassUploadForm appraisers={appraisers} species={species} onUpload={onUploadForestMass} onBack={onBack} />
    </CenteredLayout>
  );
};

export default ForestMassUploadFormView;
